module.exports = __webpack_public_path__ + "static/media/sunglass2.de629e39.jpg";